import { GqlOperationFactory, GqlQueryFactory } from '@skand/graphql-tools';
import { queryClient5 } from './client5';
import { request } from './request';

export const gqlOperationFactory = new GqlOperationFactory({ request });
export const gqlQueryFactory = new GqlQueryFactory({
  gqlOperationFactory,
  queryClient: queryClient5,
});
